import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { _FunctionalID, _NoveltyAccount, _OutputAuthorizationRequest, _RecordBudget, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { SelectIDWorkGroupBPMSingleton } from "../../../../../admin/select/SelectIDWorkGroupBPMSingleton";
import { StepWizard, Wizard } from "../../../../config/Componentes/wizard/Wizard";
import { MASK_DATE, MASK_NUMBER } from "../../../../../theme/Component/BasicMultiSelecTable";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { DocumentHeaderEditor } from "../../../../../contabilidad/bodegaDocumentos/DocumentHeaderEditor";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { ErrorList } from "../../../../../theme/Component/ErrorList";
import { DocumentViewer } from "../../../../../theme/Component/DocumentViewer";
import useModal, { MODAL_SM, MODAL_XL } from "../../../../../theme/Component/hooks/useModal";
import { BasicButton } from "../../../../../theme/Component/BasicButton";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

type listaPropsLength = {
    product: number;
    fixed: number;

}

export const ARCON002 = ({ configProcedure }: Props) => {

    const props = configProcedure?._pocessData?.Props ?? {};
    const procedure = configProcedure?._procedure ?? {};



    const { lista, setLista, instance, bean, setBean } = useDataBean(_RecordBudget);
    const [chargeDate, setChargeDate] = useState<any>(_single.getCurrenDate());

    const [documents, setDocuments] = useState<any>([]);
    const [msgList, setMsgList] = useState<any>([]);

    const [lengthList, setLengthList] = useState<number>(0);

    const modal = useModal("Agregar RP", MODAL_SM);
    const modalView = useModal("Visualizar Documento", MODAL_XL);

    useEffect(() => {
        if (props.IDAdquisitionContract) {
            getLista();
        }
    }, [props.IDAdquisitionContract])

    const getLista = () => {
        instance.getBudgetRecordForAdquisitionContract(props.IDAdquisitionContract, props.AdquisitionContractDate, chargeDate).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const updateItem = () => {
        instance.setAdquisitionContractToRP(bean.IDAdquisitionContract, bean.AdquisitionContractDate, bean.IDDocument, bean.DocumentDate, _single.getAccountID(), true).then(
            (resp) => {
                modal.close();
                setDocuments(resp.DocumentURL);
                setMsgList(resp.MsgList);
                modalView.open("Docuemnto adjunto");
                getLista();
            }
        ).catch(err => { toast.error(err) })
    }

    const createCDP = () => {
        setBean({
            IDAdquisitionContract: props.IDAdquisitionContract,
            AdquisitionContractDate: props.AdquisitionContractDate,
        });
        modal.open();
    }

    const onExportMap = () => {
        const listaRP = lista.map(({ DataBeanProperties }) => {
            const {
                IDDocument,
                Consecutive,
                DocumentDate
            } = DataBeanProperties;

            return {
                IDDocument,
                Consecutive,
                DocumentDate
            };
        });

        const listaResume = lista.map(({ DataBeanProperties }) => `${DataBeanProperties.Mnemonic}: ${DataBeanProperties.Consecutive}`).join(', ');

        configProcedure?._pushInfo?.(
            _single.jsonToBootstrapTable({
                "Registros Presupuestales Asociados": listaResume 
            })
        );

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap({ RPList: JSON.stringify(listaRP.length > 0 ? listaRP : []) })
        }


        if (configProcedure?._pushProps) {
            configProcedure?._pushProps({ RPList: JSON.stringify(listaRP.length > 0 ? listaRP : []) })
        }
    }

    const head = [
        { title: 'ID', property: 'IDDocument', visible: true, mask: MASK_NUMBER },
        { title: 'Fecha', property: 'DocumentDate', visible: true, mask: MASK_DATE },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Consecutivo Ext', property: 'ExternalReference', visible: true },
        { title: 'Estado del Documento', property: 'DocumentStateName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { createCDP() } }
    ]

    return (
        <div className="row">
            <div className="col-md-6">
                <InputDate name="" value={chargeDate} setDate={(e) => { setChargeDate(e) }} label="Fecha Actual" />
            </div>

            <BasicTable iconButtons={iconButtonsItem} body={lista} head={head} rowSet={setBean} />

            <div className="col-md-4">
                <BasicButton useMargin disable={lista.length <= 0} eventClick={() => { onExportMap() }} icon="ri-send-plane-line"  >Continuar</BasicButton>
            </div>

            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={updateItem}>
                <div className="row">
                    <div className="col-md-12">
                        <DocumentHeaderEditor label="RP Seleccionado" onChange={(e) => { setBean({ ...bean, "IDDocument": e.IDDocument, "DocumentDate": e.Since, "DocumentState": e.DocumentState, "Consecutive": e.Consecutive, "Mnemonic": e.Mnemonic, }) }} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalView.modal} updateModal={modalView.setModal}>
                {msgList.length > 0 &&
                    <ErrorList lista={msgList} />
                }
                {msgList.length === 0 && documents.length > 0 &&
                    <DocumentViewer key={documents} list={documents} />
                }
            </Modal>
        </div>
    );
}